export const workPackages = [
  {key: "WP-DEMO-001", title: "Policy-gated repository change", owner: "Product Architecture", status: "Approved", risk: "Low"},
  {key: "WP-OPS-014", title: "Runner observability baseline", owner: "Platform Operations", status: "Awaiting approval", risk: "Medium"},
  {key: "WP-SEC-009", title: "Evidence retention rules", owner: "Security", status: "Draft", risk: "Medium"}
];

export const workers = [
  {name: "Planner", key: "planner", stage: "Planning", state: "Complete", duration: "00:00"},
  {name: "Architecture conformance", key: "architecture-conformance", stage: "Architecture", state: "Complete", duration: "00:00"},
  {name: "Quality assurance", key: "qa", stage: "QA & security", state: "Complete", duration: "00:00"}
];

export const workerTypes = [
  "planner", "architecture-conformance", "backend-developer", "frontend-developer",
  "database-rls", "qa", "security", "accessibility", "documentation",
  "integration-review", "operations-monitor"
].map(key => ({
  key,
  name: key.split("-").map(part => part[0].toUpperCase() + part.slice(1)).join(" ")
}));

export const evidence = [
  {type: "Orchestration plan", digest: "6c02ae…7bc5", source: "Deterministic planner", result: "Verified"},
  {type: "Simulated execution", digest: "b02d7f…941a", source: "Capability-free provider", result: "Verified"},
  {type: "Policy decision", digest: "c9f412…21d8", source: "Default-deny engine", result: "Denied as designed"}
];

export const auditEvents = [
  {time: "14:32:08Z", actor: "authenticated-subject", action: "approval.decide", outcome: "APPROVED"},
  {time: "14:32:08Z", actor: "policy-engine", action: "gitlab.branch.create", outcome: "DENY"},
  {time: "14:32:08Z", actor: "workbench", action: "workflow.stop", outcome: "NO SIDE EFFECT"}
];
